import React from 'react';
import { v4 as uuidv4 } from 'uuid'; 
import FriendView from './FriendView.js'
import MonthlyMeeting from './MonthlyMeeting.js';
import Service from './Service.js';
import CommitteeList from './CommitteeList';
import CommitteeOYMList from './CommitteeOYMList.js';
import ServiceMandO from './ServiceMandO';
import Search from './Search';
import FriendList from './FriendList.js';
import FriendButtonList from './FriendButtonList.js';
import FriendButtonListEntry from './FriendButtonListEntry.js';
export function peek(myArray){
		 	return myArray[myArray.length-1];
		 }
export function removeDuplicates(array){
	if (array.length<=1){
		return array;
	}
	let firstElement=array[0];
	let arrayWithoutFirstElement = array.filter(element=>{
		return firstElement!=element;
	});
	let cleanArray = removeDuplicates(arrayWithoutFirstElement);
	cleanArray.unshift(firstElement);
	return cleanArray;
}	 
export function friendElement(oym,friend,dropBreadcrumb) {
	return (<FriendView key={uuidv4()} oym={oym} friend={friend} dropBreadcrumb={dropBreadcrumb} />)
}
export function monthlyMeetingElement(oym,meeting,dropBreadcrumb,authenticated) {
	return (<MonthlyMeeting key={uuidv4()} oym={oym} meeting={meeting} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>)
}
export function committeeElement(oym,committee,dropBreadcrumb,authenticated) {
	return (<Service key={uuidv4()} oym={oym} committee={committee} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>)
}
export function mandOServiceElement(oym,mandOService,dropBreadcrumb,authenticated,noOffice) {
	if (noOffice){
		return (<Service key={uuidv4()} oym={oym} committee={mandOService} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated} noTerm={true} noOffice={true}/>)
	}
	return (<Service key={uuidv4()} oym={oym} committee={mandOService} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated} noTerm={true}/>)
}
export function termElement(oym,term,dropBreadcrumb) {
	return (<Service key={uuidv4()} oym={oym} term={term} dropBreadcrumb={dropBreadcrumb} />)
}
export function mandOElement(oym,dropBreadcrumb,authenticated){
	return (<ServiceMandO key={uuidv4()} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>);
}
export function searchElement(list,oym,passedSearchItem,setSearchItem,dropBreadcrumb,authenticated){
	console.log("Defining searchElement passedSearchItem:"+passedSearchItem);
	return (<Search key={uuidv4()} list={list} oym={oym} passedSearchItem={passedSearchItem} setSearchItem={setSearchItem} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>);
}
export function committeeList(list,oym,dropBreadcrumb,authenticated){
	return (
		<CommitteeList key={uuidv4} list = {list} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
	  );
}
export function committeeOYMList(list,oym,dropBreadcrumb,authenticated){
	return (
		<CommitteeOYMList key={uuidv4} list = {list} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
	  );
}

export function friendList(list, oym, dropBreadcrumb) {
	return (
		<FriendList  key={uuidv4()} list={list} oym={oym} dropBreadcrumb={dropBreadcrumb}/>
	);
}
export function clerksElement(parrentObject,oym,dropBreadcrumb,authenticated) {
if (parrentObject.clerks!=undefined && parrentObject.clerks!=null && parrentObject.clerks.length>0 && parrentObject.clerks[1].length>0) {
	let clerks = parrentObject.clerks[1].map(friend=>oym.objectRef(friend));
	return (
		<>
		{/* Clerk or convener: {friendList(committee.clerks[1],oym,dropBreadcrumb)}<br/><br/> */}
		Clerks: <FriendButtonList list ={clerks} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
		</>
	)
	// clerks=committee.clerks[1];
} else if (parrentObject.clerk!=undefined&&parrentObject.clerk!=null){
	let friend =oym.objectRef(parrentObject.clerk);
	return (
		<>
		Clerk: <FriendButtonListEntry friend ={friend} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
		</>
	)} else {
		return (<></>);
	}
}
export function Breadcrumb (name,component){
	this.name=name;
	this.component=component;
	this.key=uuidv4();
}
export function LabledFriend (label,friend){
	this.label=label;
	this.friend=friend;
	this.key=uuidv4();
}
export function compareLabledFriend(labledFriend1,labledFriend2){
	if (labledFriend1.label < labledFriend2.label){
	  return -1;
	}
	if (labledFriend1.label > labledFriend2.label){
	  return 1;
	}
	return 0;
  }
export function screenType(){
	let width = window.innerWidth;
	if (width>=1440){
		return "Standard";
	}
	if (width>=1151){
		return "TwoLetterButton";
	}
	if (width>=964){
		return "OneLetterButton";
	}
	// if (width>=611){
		return "Small";
	// }
}
export const sessionStatusStates ={
    notAuthenticated : "Not Authenticated",
    newUser : "New user",
    authenticated : "Authenticated",
	signonCompleted : "Signon completed.  Waiting authentication.",
	signoutCompleted : "Signout completed.  Waiting revoking authentication.",
	// authenticatedBySignon : "Authenticated by Signon",  // deprecated
	authenticatedByStateChange: "Authorized by State Change",
    waitingEmailVerification : "Waiting for Email verification", // deprecated
    waitingEmailVerification2 : "Still waiting for Email verification", // deprecated
	passwordChange : "Password change email sent"
}
export function toggleWaitingForEmailVerification(sessionStatus){
	if (sessionStatus===sessionStatusStates.waitingEmailVerification){
		return sessionStatusStates.waitingEmailVerification2;
	}
	if (sessionStatus===sessionStatusStates.waitingEmailVerification2){
		return sessionStatusStates.waitingEmailVerification;
	}
	return sessionStatus;
}
export function getMandOOffice(oym,friend){
	let ministryAndOversightServiceObjects=oym.whichministryAndOversightService(friend);
	let offices = [];
	for (let servicex in ministryAndOversightServiceObjects){
		if (ministryAndOversightServiceObjects[servicex].name==="Ministers"){
			offices.push("Minister");
		} else if (ministryAndOversightServiceObjects[servicex].name==="Elders"){ 
			offices.push("Elder");
		} else if (ministryAndOversightServiceObjects[servicex].name==="Overseers"){
			offices.push("Overseer");
		}
	}
	return (<>{offices.toString()}</>)
}